// Read more about these google events here: https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag

export class TagManager
{
	static Events = {
		AddPaymentInfo: "add_payment_info",
		AddShippingInfo: "add_shipping_info",
		AddToCart: "add_to_cart",
		AttentiveDownload: "attentiveDownload",
		EmailModalSignup: "emailModalSignup",
		RemoveFromCart: "remove_from_cart",
		SaveForLater: "add_to_wishlist",
		Search: "search",
		SignUp: "sign_up",
		SmsModalSignup: "smsModalSignup"
	};

	static AddProperty(propertyName: string, propertyValue: string): void
	{
		if (typeof window.dataLayer !== "undefined")
		{
			var property = {};
			property[propertyName] = propertyValue;
			window.dataLayer.push(property);
		}
	}

	static CallEvent(eventName: string, parameters?: Gtag.EventParams): void
	{
		const config = {
			event: eventName,
			...parameters
		};

		if (typeof window.dataLayer !== "undefined")
		{
			window.dataLayer.push(config);
		}
	}

	static Search(term: string): void
	{
		TagManager.CallEvent(this.Events.Search, <Gtag.EventParams>{
			search_term: term
		});
	}

	static SaveForLater(items: [Gtag.Item]): void
	{
		TagManager.CallEvent(this.Events.SaveForLater, {
			items: items
		});
	}
}

if (typeof window.Fun.TagManager === "undefined")
{
	window.Fun.TagManager = TagManager;
}